import { axiosInstance } from "../../services/axiosInstace";
import { formatUrlQuery } from "utils/helper";
import { GET_TERMINALS, GET_TERMINAL_REQUESTS } from "../types";
import {
  asyncActionStart,
  asyncActionFinish,
} from "../../asyncLoading/AsyncAction";

const config = {
  headers: {
    "Content-Type": "application/json",
  },
};

export const getTerminals = (requestParams) => async (dispatch) => {
  try {
    dispatch(asyncActionStart());
    const res = await axiosInstance.get(`/api/tms/portal/terminals`, {
      params: {
        ...requestParams,
      },
    });
    dispatch({
      type: GET_TERMINALS,
      payload: res.data.data.content,
    });
    dispatch(asyncActionFinish());
  } catch (err) {
    console.log(err);
  }
};

export const getTerminalRequests = (requestParams) => async (dispatch) => {
  try {
    dispatch(asyncActionStart());
    const res = await axiosInstance.get(
      `/api/tms/portal/terminals/request?${formatUrlQuery(requestParams)}`,
      {
        params: {
          ...requestParams,
        },
      }
    );
    dispatch({
      type: GET_TERMINAL_REQUESTS,
      payload: res.data.data,
    });
    dispatch(asyncActionFinish());
  } catch (err) {
    console.log(err);
  }
};

export const postRequestForTerminal = (data) => {
  return axiosInstance.post("/api/tms/portal/terminals/request", data, config);
};

export const postMapTerminal = (data) => {
  return axiosInstance.post("/api/tms/portal/terminals/assign", data, config);
};
